export interface ImageType {
  id: number;
  is_public: boolean;
  is_uploaded: boolean;
  is_image: boolean;
  locked: boolean;
  ownership_type: OwnershipType;
  ownership_type_name: string;
  extension: string;
  original_name: string;
  alt: string;
  date_created: string;
  date_uploaded: string;
  version_id: string;
  public_s3_url: string;
  get_object_presigned_url: string;
}

export enum OwnershipType {
  ROOT = 1,
  MERCHANT = 2,
  USER = 3,
  SILAL = 4,
}
